module.exports = __webpack_public_path__ + "static/media/call-feedback-all-good-color.0842df0e.svg";